// QRContentTypeSelector.jsx - Updated to use Context
import React from 'react';
import styled from '@emotion/styled';
import { QrCode, Type, User } from 'lucide-react';

const ContentTypeSelector = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
`;

const ContentTypeCard = styled.button`
  background: ${({ active }) =>
    active ? 'rgba(124, 58, 237, 0.20)' : 'rgba(255, 255, 255, 0.05)'};
  border: 1px solid
    ${({ active }) =>
      active ? 'rgba(124, 58, 237, 0.60)' : 'rgba(255, 255, 255, 0.20)'};

  border-radius: 16px;
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.25s ease;

  color: ${({ active }) => (active ? '#FFFFFF' : '#F3F4F6')};

  &:hover {
    background: rgba(124, 58, 237, 0.3);
    border-color: rgba(124, 58, 237, 0.7);
    color: #ffffff;
  }
`;

const IconWrapper = styled.div`
  margin: 0 auto 0.5rem;
  display: flex;
  justify-content: center;
`;

const CardTitle = styled.div`
  font-weight: 600;
  font-size: 1.5rem;
`;

const CardDescription = styled.div`
  font-size: 1.2rem;
  opacity: 0.8;
  margin-top: 0.25rem;
`;

const QRContentTypeSelector = ({ contentType, setContentType }) => {
  const contentTypes = [
    {
      id: 'url',
      title: 'Website URL',
      description: 'Link to any website',
      icon: QrCode,
    },
    {
      id: 'text',
      title: 'Plain Text',
      description: 'Any text content',
      icon: Type,
    },
    {
      id: 'contact',
      title: 'Contact Info',
      description: 'vCard contact details',
      icon: User,
    },
  ];

  return (
    <ContentTypeSelector>
      {contentTypes.map((type) => {
        const IconComponent = type.icon;
        return (
          <ContentTypeCard
            key={type.id}
            active={contentType === type.id}
            onClick={() => setContentType(type.id)}
            type="button"
          >
            <IconWrapper>
              <IconComponent size={24} />
            </IconWrapper>
            <CardTitle>{type.title}</CardTitle>
            <CardDescription>{type.description}</CardDescription>
          </ContentTypeCard>
        );
      })}
    </ContentTypeSelector>
  );
};

export default QRContentTypeSelector;
